import DisclaimerInfo from "../components/DisclaimerInfo";

const DisclaimerPage = () => {
  return (
    <>
      <div className="div-odd">
        {/* <DisclaimerInfo /> */}
        <h1>Coming soon. . . </h1>
      </div>
    </>
  );
};

export default DisclaimerPage;
